import { kc } from "@/main";
import config from "@/config/env/index";

const handleLogout = (immediately?: boolean) => {
  setTimeout(
    function () {
      window.location.href = "/";
      kc.logout();
    },
    immediately ? 200 : config.snackbarTimeout
  );
};

export default handleLogout;
